import React from 'react';
export const FooterSection = () => {
  return <footer className="bg-familia-bg border-t border-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-90">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-91">
        <div className="flex flex-col items-center text-center mb-8 md:mb-12" data-id="element-92">
          <div className="flex flex-col mb-4" data-id="element-93">
            <span className="text-familia-cyan font-display text-2xl sm:text-3xl font-bold leading-tight" data-id="element-94">
              📚 VITALIDAD 360™
            </span>
            <span className="text-familia-gray text-xs sm:text-sm font-semibold tracking-widest uppercase mt-1" data-id="element-95">
              Master Kit Adultos Mayores
            </span>
          </div>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-familia-gray mt-8" data-id="element-96">
            <a href="mailto:soporte@vitalidad360.com" className="hover:text-familia-cyan transition-colors" data-id="element-97">
              📧 soporte@vitalidad360.com
            </a>
            <a href="#" className="hover:text-familia-cyan transition-colors" data-id="element-98">
              📲 @vitalidad360
            </a>
            <a href="#" className="hover:text-familia-cyan transition-colors" data-id="element-99">
              🌐 www.vitalidad360.com
            </a>
          </div>
        </div>
        <div className="w-full h-px bg-familia-cyan/15 mb-12" data-id="element-100" />
        <div className="max-w-4xl mx-auto space-y-6 text-center text-[10px] sm:text-xs text-familia-gray leading-relaxed" data-id="element-101">
          <p data-id="element-102">
            © VITALIDAD 360™ 2026 — Todos los derechos reservados. Prohibida
            la reproducción sin autorización expresa.
          </p>
          <p data-id="element-103">
            VITALIDAD 360™ es un producto digital de contenido educativo para
            familias argentinas y latinoamericanas a cargo del cuidado de
            adultos mayores. No reemplaza la consulta médica profesional. Los
            resultados dependen del compromiso y la dedicación de cada familia y
            cuidador.
          </p>
        </div>
      </div>
    </footer>;
};